import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
//import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import type { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, BulletChart, BubbleChart } from "../../components/charts";

const activityProgress = [
  { label: "Chaîne logistique", value: 74, color: "#116B43" },
  { label: "Pilotage stratégique", value: 61, color: "#163A5F" },
  { label: "Sécurisation des sites", value: 48, color: "#D68910" },
  { label: "Transformation digitale", value: 57, color: "#2471A3" },
];

const activityBudgetAlignment = [
  { label: "Optimiser logistique", value: 68, color: "#116B43" },
  { label: "Renforcer gouvernance", value: 52, color: "#163A5F" },
  { label: "Sécuriser les dépôts", value: 39, color: "#C0392B" },
  { label: "Moderniser SI", value: 46, color: "#2471A3" },
];

const activityCostPressure = [
  { label: "Maintenance Bingo", value: 73, color: "#D68910" },
  { label: "Interfaces JDE/LAS", value: 41, color: "#163A5F" },
  { label: "Astreintes & pointage", value: 58, color: "#116B43" },
  { label: "Réplication infra", value: 64, color: "#C0392B" },
];

const progressTrend = [28, 34, 39, 44, 51, 58, 62, 67, 69, 72, 76, 81];

const criticalActivities = [
  {
    title: "Sécurisation des dépôts",
    description: "L’avancement physique est inférieur à la consommation budgétaire observée sur la période.",
    tone: "danger" as const,
  },
  {
    title: "Infrastructure de réplication",
    description: "L’activité reste sensible sur les coûts et nécessite un arbitrage de périmètre ou de calendrier.",
    tone: "warning" as const,
  },
  {
    title: "Optimisation de la chaîne logistique",
    description: "L’activité progresse bien et reste globalement cohérente avec l’allocation budgétaire.",
    tone: "success" as const,
  },
];

const activityKpiLink = [
  { label: "Axe 1 · Logistique", value: 74, color: "#116B43" },
  { label: "Axe 4 · Gouvernance", value: 63, color: "#163A5F" },
  { label: "Axe 3 · Exécution", value: 55, color: "#2471A3" },
  { label: "Axe 2 · Croissance", value: 42, color: "#D68910" },
];

export default class ActivityDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const { activityProgress={},activityBudget={},activityByCostCenter={} } = sections;
  const { criticalActivities={},activityOutputs={},activityDrivers={} } = sections;

  const iconMap: any = {
    wallet: <AccountBalanceWalletOutlinedIcon />,
    activity: <AssignmentTurnedInOutlinedIcon />,
    track: <TrackChangesOutlinedIcon />,
    //investment: <BusinessCenterOutlinedIcon />,
    //expense: <ReceiptLongOutlinedIcon />,
    equalizer: <EqualizerOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
  };

  
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard Activités"
        subtitle="Vue d’exécution des programmes, de l’avancement physique, de la cohérence budgétaire et des activités critiques."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", lg: "1.35fr 1fr" } }}>
        <SectionCard
          title={activityProgress.title || ""}
          subtitle={activityProgress.subtitle || ""}
        >
          <BulletChart data={(activityProgress.data || [])} />
        </SectionCard>

        <SectionCard
          title={criticalActivities.title || ""}
          subtitle={criticalActivities.subtitle || ""}
        >
          <Box sx={{ maxHeight: 360, overflowY: "auto", pr: 0.5 }}>
          <AlertList items={(criticalActivities.data || [])} />
          </Box>
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr" }}>
        <SectionCard
          title={activityBudget.title || ""}
          subtitle={activityBudget.subtitle || ""}
        >
          <AreaTrendChart data={activityBudget.data || []} />
        </SectionCard>
      </Box>

     <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", lg: "repeat(3, 1fr)" } }}>
        <SectionCard
          title={activityByCostCenter.title || ""}
          subtitle={activityByCostCenter.subtitle || ""}
        >
          <TreemapChart data={activityByCostCenter.data || []} />
        </SectionCard>

        <SectionCard
          title={activityOutputs.title || ""}
          subtitle={activityOutputs.subtitle || ""}
        >
          <DonutChart data={activityOutputs.data || []} />
        </SectionCard>

        <SectionCard
          title={activityDrivers.title || ""}
          subtitle={activityDrivers.subtitle || ""}
        >
          <BarChart horizontal data={(activityDrivers.data || [])}
          />
        </SectionCard>
      </Box>


      {/* <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Activités planifiées"
          value="48"
          subtitle="Portefeuille actif"
          delta="FY2025"
          tone="info"
          icon={<AssignmentTurnedInOutlinedIcon />}
        />
        <SummaryCard
          title="En cours"
          value="31"
          subtitle="Activités actives"
          delta="64,6%"
          tone="success"
          icon={<PendingActionsOutlinedIcon />}
        />
        <SummaryCard
          title="À risque"
          value="7"
          subtitle="Suivi renforcé"
          delta="3 urgentes"
          tone="warning"
          icon={<WarningAmberOutlinedIcon />}
        />
        <SummaryCard
          title="Coût engagé"
          value="12,8 Md"
          subtitle="Sur les activités suivies"
          delta="18,3%"
          tone="default"
          icon={<MonetizationOnOutlinedIcon />}
        />
        <SummaryCard
          title="Liaison KPI"
          value="83%"
          subtitle="Activités reliées"
          delta="+4 pts"
          tone="success"
          icon={<HubOutlinedIcon />}
        />
        <SummaryCard
          title="Score moyen"
          value="66%"
          subtitle="Avancement consolidé"
          delta="Stable"
          tone="info"
          icon={<InsightsOutlinedIcon />}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard
            title="Tendance d’avancement des activités"
            subtitle="Lecture synthétique de la progression consolidée des activités sur l’exercice."
            action={<StatusBadge label="Portefeuille global" tone="info" />}
          >
            <MockTrendChart points={progressTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Activités critiques"
            subtitle="Points d’attention nécessitant un arbitrage ou un suivi renforcé."
          >
            <AlertList items={criticalActivities} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Avancement par programme"
            subtitle="Lecture comparée des grands blocs d’activités."
          >
            <MockBarChart data={activityProgress} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alignement budget / activité"
            subtitle="Niveau de cohérence entre allocation budgétaire et progression observée."
            action={<StatusBadge label="Budget link" tone="warning" />}
          >
            <MockBarChart data={activityBudgetAlignment} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Pression de coût"
            subtitle="Activités sous tension en matière de coût ou d’effort."
          >
            <MockBarChart data={activityCostPressure} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture opérationnelle"
            subtitle="Messages de pilotage à retenir pour la période."
          >
            <Stack spacing={1.25}>
              {[
                ["Le portefeuille avance correctement", "La majorité des activités critiques restent dans une trajectoire maîtrisée, mais certaines activités d’infrastructure exigent une revue rapprochée."],
                ["La cohérence budget / progrès doit être renforcée", "Quelques activités consomment rapidement les ressources sans progression physique équivalente."],
                ["Les activités stratégiques sont mieux reliées aux KPI", "Le niveau de traçabilité entre activité, axe stratégique et performance s’améliore progressivement."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Activités reliées aux axes KPI"
            subtitle="Vue simplifiée du lien entre activités et performance stratégique."
          >
            <Stack spacing={1.5}>
              <MockBarChart data={activityKpiLink} />
            </Stack>
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}
